import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Calendar } from "lucide-react";

import { useDelayedFlag, useTran } from "@/hooks";
import { SearchableSelect } from "@/components/common";
import { Skeleton } from "@/components/ui/skeleton";

import { useEsgDashboardStore } from "../../hooks";

const YearSelector = observer(() => {
  const { t } = useTran();
  const {
    availableYears,
    dashboardYear,
    loading,
    ensureData,
    setDashboardYear,
  } = useEsgDashboardStore();

  const showSkeleton = useDelayedFlag(loading);

  useEffect(() => {
    ensureData();
  }, [ensureData]);

  const yearOptions = availableYears.map((year) => ({
    value: String(year),
    label: String(year),
  }));

  return (
    <div className="rounded-radius border border-border bg-card p-4 shadow-sm">
      <div className="mb-3 flex items-center gap-2">
        <Calendar className="h-4 w-4 text-primary" />
        <label className="text-sm font-medium text-foreground">
          {t("Dashboard Year")}
        </label>
      </div>
      {showSkeleton ? (
        <Skeleton className="h-9 w-full" />
      ) : (
        <SearchableSelect
          value={String(dashboardYear)}
          onChange={(value) => setDashboardYear(Number(value))}
          options={yearOptions}
          placeholder={t("Select year")}
          searchPlaceholder={t("Search year")}
          emptyText={t("No year available")}
        />
      )}
      <p className="mt-2 text-xs text-muted-foreground">
        {t("Currently viewing")}: {dashboardYear}
      </p>
    </div>
  );
});

export default YearSelector;
